<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="backAction">返回</el-button>
          <el-button style="margin-right: 16px;" class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
              <el-form-item label="单图类型:">
                <el-select v-model="formInlineTmp.type" placeholder="请选择" @change="searchData">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="创建人:">
                <el-input v-model="formInlineTmp.createUsrName" placeholder="请输入创建人" clearable></el-input>
              </el-form-item>
              <el-form-item label="单图名称:">
                <el-input v-model="formInlineTmp.name" placeholder="请输入单图名称" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">单图列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <!-- <el-button type="primary" @click="addBoardAction" class="add-btn" style="float: right;">添加</el-button> -->
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <template slot="empty">
          <div class="newTableEmpty">没有更多数据了</div>
        </template>
        <el-table-column
          prop="modelName"
          label="受众类型">
        </el-table-column>
        <el-table-column
          label="单图类型">
          <template slot-scope="scope">
            <div v-if="scope.row.type === 1">受众分析</div>
            <div v-if="scope.row.type === 2">行为分析</div>
            <div v-if="scope.row.type === 3">漏斗分析</div>
            <div v-if="scope.row.type === 4">订单分析</div>
            <div v-if="scope.row.type === 5">RFM分析</div>
            <div v-if="scope.row.type === 6">复购分析</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="单图名称">
        </el-table-column>
        <el-table-column
          prop="createUsrName"
          label="创建人"
          width="135">
        </el-table-column>
        <el-table-column
          width="180"
          label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.add === 0" @click="addSingleChartAction(scope.row.id)">
              <span class="add-div">添加</span>
            </div>
            <div v-if="scope.row.add === 1" @click="deleteDashboardAction(scope.row.id)">
              <span class="add-div">取消添加</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="看板基本信息"
      :visible.sync="dialogVisible"
      width="520px"
      class="cellDialog">
      <el-form :model="addBoardForm" label-width="110px"  ref="addBoardForm" :rules="rules" >
        <el-form-item label="看板名称" prop="name">
          <el-input v-model="addBoardForm.name" placeholder="请输入看板名称(20字以内)" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" style="margin-right: 20px" @click="closeDialogAction">关 闭</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 20px" @click="submitForm('addBoardForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { getDashBoardList, addDashBoard, deleteDashboard, getDashBoardSingleChartList, addSingleChartToDashBoard, deleteSingleChartFromeDashBoard } from '@/api/analyse.js'

export default {
  name: 'addSingleChart',
  data () {
    return {
      typeOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '受众分析',
          value: '1'
        },
        {
          label: '行为分析',
          value: '2'
        }
        // {
        //   label: '漏斗分析',
        //   value: '3'
        // },
        // {
        //   label: '订单分析',
        //   value: '4'
        // },
        // {
        //   label: 'RFM分析',
        //   value: '5'
        // },
        // {
        //   label: '复购分析',
        //   value: '6'
        // }
      ],
      rules: {
        name: [
          { required: true, message: '请输入看板名称', trigger: 'blur' }
        ]
      },
      addBoardForm: {
        name: ''
      },
      dialogVisible: false,
      formInlineTmp: {
        type: '',
        createUsrName: '',
        name: ''
      },
      formInline: {
        type: '',
        createUsrName: '',
        name: ''
      },
      loading: false,
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      myStorage: window.localStorage,
      dashBoardId: window.localStorage.getItem('dashBoardId'),
      figuresArray: [],
      layout: []
    }
  },
  methods: {
    // 返回
    backAction() {
      router.push({ path: '/home/board-list' })
    },
    addSingleChartAction(figureId) {
      addSingleChartToDashBoard(this.dashBoardId, figureId).then(res => {
        if (res.data.code === 0) {
          let array = JSON.parse(this.myStorage.getItem('itemFigures'))
          let layoutArr = JSON.parse(this.myStorage.getItem('itemLayout'))
          let maxY = 0
          if (layoutArr.length >= 2) {
            for (let x = 0; x < layoutArr.length - 1; x++) {
              if (layoutArr[x].y !== null) {
                maxY = maxY < layoutArr[x + 1].y ? layoutArr[x + 1].y : maxY
              }
            }
          }
          array.push({
            id: res.data.data.id,
            position: [0, maxY + 9, 9, 6],
            type: res.data.data.type,
            name: res.data.data.name
          })
          layoutArr.push({
            'x': 0,
            'y': maxY + 9,
            'w': 9,
            'h': 6,
            'i': res.data.data.id,
            'showType': '',
            'name': res.data.data.name,
            'type': res.data.data.type
          })
          this.myStorage.setItem('itemFigures', JSON.stringify(array))
          this.myStorage.setItem('itemLayout', JSON.stringify(layoutArr.reverse()))
          _g.toastMsg('success', '添加成功')
        } else {
          _g.toastMsg('error', res.data.des)
        }
        this.getData()
      })
    },
    closeDialogAction() {
      this.dialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDashBoardAction()
        } else {
          return false
        }
      })
    },
    addBoardAction() {
      this.dialogVisible = true
    },
    addDashBoardAction() {
      addDashBoard(this.addBoardForm.name).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('error', res.data.des)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    // handleChange() {},
    searchData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    deleteDashboardAction(itemId) {
      this.$confirm('确定从当前看板移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSingleChartFromeDashBoard(this.dashBoardId, itemId).then(res => {
          if (res.data.code === 0) {
            this.layout = JSON.parse(window.localStorage.getItem('itemLayout'))
            this.figuresArray = JSON.parse(window.localStorage.getItem('itemFigures'))
            for (let one of this.figuresArray) {
              if (one.id === itemId) {
                let index = this.figuresArray.indexOf(one)
                this.figuresArray.splice(index, 1)
              }
            }
            for (let two of this.layout) {
              if (two.i === itemId) {
                let index = this.layout.indexOf(two)
                this.layout.splice(index, 1)
              }
            }
            this.myStorage.setItem('itemFigures', JSON.stringify(this.figuresArray))
            this.myStorage.setItem('itemLayout', JSON.stringify(this.layout))
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.des)
          }
          this.getData()
        })
      }).catch((error) => {
      })
    },
    getData() {
      this.loading = true
      getDashBoardSingleChartList(this.page, this.limit, this.formInline.type, this.formInline.name, this.formInline.createUsrName, this.dashBoardId).then(res => {
        if (res.data.code === '200') {
          this.totalCount = res.data.result.total
          this.tableData = res.data.result.data
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.enable-button {
  color: #1980FF;
  cursor: pointer;
  font-size: 14px;
}
.right {
  width: 370px;
}
.add-div {
  cursor: pointer;
  color: #1980FF;
}
</style>
